<template>
  <div class="container-fluid bg-success text-white">
    <div class="row title-card">
      <div class="col-10 text-left"><span v-show="spinner"><icon name="cog" scale="2.5" spin></icon></span> <h4>Próximos</h4></div>
      <div class="col-2 text-right"><b-link class="text-white" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row pb-4" v-if="level == 'supervisor'">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center">
        <select class="custom-select" v-model="store" @change="setStore()">
                <option value="all">Todas as Lojas</option>
                <option v-for="(store, index) in stores" v-bind:key="'store-'+index" v-bind:value="store.id_store">{{ store.nm_store }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3">
        <ul class="nav-menu">
          <li><b-link class="active" :to="{ name: 'proximos' }">Data</b-link></li>
          <li><b-link :to="{ name: 'checklist' }">Checklist</b-link></li>
        </ul>
      </div>
    </div>
    <div class="row mt-2" v-for="(proximo, index) in proximos.checks" v-bind:key="'p'+index" v-bind:id="'proximos-'+index">
      <div class="col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"><strong class="d-block">{{ proximo.days }}</strong> <span v-if="proximo.days == 1">dia</span><span v-if="proximo.days > 1">dias</span></div>
      <div class="col-8 col-md-6 col-lg-4">
        <span>
          {{ proximo.nm_check }}
          <span v-if="proximo.dt_holiday_dif > 0" class="holiday">(Férias)</span>
        </span>
        <h5>
          {{ proximo.nm_store }}
        </h5>
      </div>
      <div class="col-2 col-md-1 col-lg-1 text-center">
        <b-link v-if="level == 'supervisor'" class="text-white" :to="{ name: 'check', params: { type: 'proximo', store: proximo.id_store, check: proximo.id_check }}"><icon name="edit" scale="2"></icon></b-link>
        <b-link v-if="level == 'store'" class="text-white" :to="{ name: 'history', params: { store: proximo.id_store, check: proximo.id_check }}"><icon name="info-circle" scale="2"></icon></b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
  components: { Icon },
  data () {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      proximos: []
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted () {
    http.get('/store/own').then(response => { this.stores = response.data; })
    http.get('/checks/proximos/'+localStorage.getItem('global-store')+'/date').then(response => { this.spinner = false; this.proximos = response.data; })
  },
  methods: {
    setStore () {
            localStorage.setItem('global-store', this.store)
            location.reload()
    }
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0 20px; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#28A745; background:#FFF; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; color:#FFF; line-height:40px; }

.nav-menu { background:#27A243; list-style:none; padding:5px 10px; }
.nav-menu li { display:inline; }
.nav-menu li a { display:inline-block; color:#FFF; padding:8px 14px; border-radius:6px; }
.nav-menu li a.active { background:#23933b; color:#FFF; }
.holiday{ font-size: 8px; }
</style>



// WEBPACK FOOTER //
// src/components/Proximos.vue